import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Spin } from 'antd';
import HomePage from '../Pages/Home/HomePage';
import AccountPage from '../Pages/Account/AccountPage';
import NotFoundPage from '../Pages/NotFound/NotFoundPage';
import LoginPage from '../Pages/Login/LoginPage';
import { RequireAuth } from '../auth/RequireAuth';
import { RoleGate } from '../auth/RoleGate';
import { MainLayout } from './MainLayout';

const CreateNew = React.lazy(() => import('../Pages/CreateNew/CreateNew'));
const DataBaseV3 = React.lazy(() => import('../Pages/DataBaseV3/DataBaseV3'));
const PostgresStoragePage = React.lazy(() => import('../Pages/PostgresStorage/PostgresStoragePage'));
const EbookPage = React.lazy(() => import('../Pages/Ebook/EbookPage'));
const TestCatalogPage = React.lazy(() => import('../Pages/TestCatalog/TestCatalogPage'));
const TestTreePage = React.lazy(() => import('../Pages/TestTree/TestTreePage'));
const ProjectTestsPage = React.lazy(() => import('../Pages/ProjectTests/ProjectTestsPage'));

function RouteFallback() {
    return (
        <div className="app-route-fallback" role="status" aria-live="polite">
            <Spin size="large" />
        </div>
    );
}

/**
 * Top-level route table. `/login` is public; all other app routes require Firebase Auth.
 */
export function AppRoutes() {
    return (
        <Suspense fallback={<RouteFallback />}>
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route element={<RequireAuth />}>
                    <Route element={<MainLayout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/test-catalog" element={<TestCatalogPage />} />
                        <Route path="/test-tree" element={<TestTreePage />} />
                        <Route path="/project-tests" element={<ProjectTestsPage />} />
                        <Route
                            path="/create-new"
                            element={
                                <RoleGate minRole="editor">
                                    <CreateNew />
                                </RoleGate>
                            }
                        />
                        <Route path="/firebase-storage" element={<DataBaseV3 />} />
                        <Route path="/postgres-storage" element={<PostgresStoragePage />} />
                        <Route path="/ebook" element={<EbookPage />} />
                        <Route path="/account" element={<AccountPage />} />
                        <Route path="/database" element={<Navigate to="/firebase-storage" replace />} />
                        <Route path="/database-v3" element={<Navigate to="/firebase-storage" replace />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Route>
                </Route>
            </Routes>
        </Suspense>
    );
}
